import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { useDisabled, DisabledContext } from '@hh.ru/magritte-common-use-disabled';

const LoadingContext = createContext(false);
const LoadingContextProvider = ({ loading, children }) => {
    const disabled = useDisabled();
    return (jsx(LoadingContext.Provider, { value: loading || false, children: jsx(DisabledContext.Provider, { value: loading || disabled, children: children }) }));
};
const useLoadingState = () => useContext(LoadingContext);

export { LoadingContextProvider, useLoadingState };
//# sourceMappingURL=index.js.map
